module.exports = __webpack_public_path__ + "static/scale-model-of-hollywood-florida-8b9ff0c5fe78d02d148b8215e6050062.png";